import type { DocumentSection, Group, Row } from "./types";

export function isRow(section: DocumentSection): section is Row {
  return 'columns' in section;
}

export function isGroup(section: DocumentSection): section is Group {
  return 'rows' in section;
}
